/**
 * Routing related helpers
 *
 * @author Nachiket Kakatkar <nachiket@helpshift.com>
 * @created Apr 27, 2023
 * @module "helpers/routing"
 */

import embedModeHelpers from "helpers/embedMode";

const DEFAULT_BASE_PATH = "/admin/";

const getAdminBasePath = () => {
  return embedModeHelpers.isEmbedModeEnabled()
    ? embedModeHelpers.getEmbedModeDashboardBasePath()
    : DEFAULT_BASE_PATH;
};

export default {
  getAdminBasePath
};
